var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v("Преподаватели")])]),_c('v-col',[_c('server-data',{attrs:{"method":_vm.$api.system.getTeacherLevels},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var serverData = ref.serverData;
return [_c('v-crud-datatable',{staticClass:"sdo-card pa-4",attrs:{"headers":_vm.headers,"method-create":_vm.$api.teachers.create,"method-list":function (ref) {
	var params = ref.params;

	return _vm.$api.teachers.index(Object.assign({}, params, _vm.teachersQuery));
},"method-view":_vm.$api.teachers.get,"method-update":_vm.$api.teachers.update,"method-delete":function (ref) {
	var ref$1;

	var args = ref.args;
	return (ref$1 = _vm.$api.teachers).delete.apply(ref$1, args);
},"dialog-edit-props":{ 'content-class': 'overflow-y-auto' }},scopedSlots:_vm._u([{key:"search-fields",fn:function(ref){
var searchKeys = ref.searchKeys;
var runSearch = ref.runSearch;
return [_c('v-text-field',{attrs:{"label":"ФИО","rounded":"","filled":""},on:{"change":runSearch},model:{value:(searchKeys['search[name]']),callback:function ($$v) {_vm.$set(searchKeys, 'search[name]', $$v)},expression:"searchKeys['search[name]']"}})]}},(serverData)?{key:"item.level_id",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm._f("levelOutput")(item.level_id,serverData)))])]}}:null],null,true)})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }